var state = {
  //关键指标
  key: 1,
  //分析项
  analysisType: 1,
  //分析维度
  analysisAxis: 1,
  //样本类型
  sampleType: 0,
  //对比项
  comparisonItem: 1,
  //龋均情况
  averageToothType: 1,
  //龋病情况
  dieaseToothType: 1,
  //超重与肥胖情况
  overWeightType: 1,
  //营养不良情况
  lessNutritionType: 1
};
var mutations = {
  SET_KEY: function SET_KEY(state, key) {
    state.key = key;
  },
  SET_ANALYSIS_TYPE: function SET_ANALYSIS_TYPE(state, analysisType) {
    state.analysisType = analysisType;
  },
  SET_ANALYSIS_AXIS: function SET_ANALYSIS_AXIS(state, analysisAxis) {
    state.analysisAxis = analysisAxis;
  },
  SET_SAMPLE_TYPE: function SET_SAMPLE_TYPE(state, sampleType) {
    state.sampleType = sampleType;
  },
  SET_COMPARISON_ITEM: function SET_COMPARISON_ITEM(state, comparisonItem) {
    state.comparisonItem = comparisonItem;
  },
  SET_AVERAGE_TOOTH_TYPE: function SET_AVERAGE_TOOTH_TYPE(state, averageToothType) {
    state.averageToothType = averageToothType;
  },
  SET_DIEASE_TOOTH_TYPE: function SET_DIEASE_TOOTH_TYPE(state, dieaseToothType) {
    state.dieaseToothType = dieaseToothType;
  },
  SET_OVER_WEIGHT_TYPE: function SET_OVER_WEIGHT_TYPE(state, overWeightType) {
    state.overWeightType = overWeightType;
  },
  SET_LESS_NUTRITION_TYPE: function SET_LESS_NUTRITION_TYPE(state, lessNutritionType) {
    state.lessNutritionType = lessNutritionType;
  }
};
var actions = {
  setKey: function setKey(_ref, key) {
    var commit = _ref.commit;
    commit('SET_KEY', key);
  },
  setAnalysisType: function setAnalysisType(_ref2, analysisType) {
    var commit = _ref2.commit;
    commit('SET_ANALYSIS_TYPE', analysisType);
  },
  setAnalysisAxis: function setAnalysisAxis(_ref3, analysisAxis) {
    var commit = _ref3.commit;
    commit('SET_ANALYSIS_AXIS', analysisAxis);
  },
  setSampleType: function setSampleType(_ref4, sampleType) {
    var commit = _ref4.commit;
    commit('SET_SAMPLE_TYPE', sampleType);
  },
  setComparisonItem: function setComparisonItem(_ref5, comparisonItem) {
    var commit = _ref5.commit;
    commit('SET_COMPARISON_ITEM', comparisonItem);
  },
  setAverageToothType: function setAverageToothType(_ref6, averageToothType) {
    var commit = _ref6.commit;
    commit('SET_AVERAGE_TOOTH_TYPE', averageToothType);
  },
  setDieaseToothType: function setDieaseToothType(_ref7, dieaseToothType) {
    var commit = _ref7.commit;
    commit('SET_DIEASE_TOOTH_TYPE', dieaseToothType);
  },
  setOverWeightType: function setOverWeightType(_ref8, overWeightType) {
    var commit = _ref8.commit;
    commit('SET_OVER_WEIGHT_TYPE', overWeightType);
  },
  setLessNutritionType: function setLessNutritionType(_ref9, lessNutritionType) {
    var commit = _ref9.commit;
    commit('SET_LESS_NUTRITION_TYPE', lessNutritionType);
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};